import axios from 'axios';

// Crear instancia de axios con configuración base
const instanceAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:7002',
  timeout: 30000, // Aumentado a 30 segundos para operaciones pesadas
  withCredentials: true, // IMPORTANTE: Enviar cookies de sesión
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para requests - agregar token si existe
instanceAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para responses - manejar errores globalmente
instanceAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Solo redirigir al login si es un error de autenticación en rutas específicas
    // NO redirigir automáticamente para permitir manejo personalizado de errores
    if (error.response?.status === 401) {
      // NO hacer redirect automático, dejar que cada componente maneje el error
    }
    return Promise.reject(error);
  }
);

export default instanceAPI;
